import React from 'react';

import './RetailContributionsEditor.scss';

import BankAssociableText from '../../../Shared/BankAssociableText/BankAssociableText';
import CurrencyInput from '../../../Shared/CurrencyInput/CurrencyInput';
import If from '../../../Shared/If/If';
import RI2020DividendText from '../../../Shared/RI2020DividendText/RI2020DividendText';
import { isIRA } from '../../../../utils/IRA/IRA-utility';
import {
  isAppBuy,
  isBuy,
  isCollegeContribute,
  isRecurringBuy,
} from '../../../../utils/transactions-util';
import { currency, currencyNoPrecision } from '../../../../utils/utils';
import { getFundMinimum } from '../../../../utils/funds/funds-utility';

export const RetailContributionsEditor = ({
  actions,
  collegePlanMaxValue,
  fund,
  fundClassName,
  maxValue,
  minValue,
}) => {
  const styleSuffix =
    isBuy() || isCollegeContribute() || isAppBuy() ? '' : '-recurring';

  const minimum = fund.sweep ? getFundMinimum(fund) : minValue;
  return (
    <div
      className={`retail-contribution-editor-txt-div-parent${styleSuffix}`}
      id={`e2e-retailContributions-${fund.ticker}`}
    >
      <div className={`retail-contribution-editor-txt-div${styleSuffix}`}>
        <div className={`retail-contribution-editor-info${styleSuffix}`}>
          Enter an Amount
        </div>
        <CurrencyInput
          ariaLabel="Funding Amount"
          autoFocus={fund.selected}
          defaultValue={fund.currentYearAmount}
          error={fund.currentYearError || fund.collegePlanMaxError}
          id={`amt-${fund.agreementID}`}
          onChange={(value) =>
            actions.updateFundAmount(
              fund.agreementID,
              value,
              'currentYearAmount',
              fund.BPID,
              isIRA(fund)
            )
          }
          displayErrorMessage={false}
        />
      </div>
      <div
        className={`retail-contribution-editor-info1 ${
          fund.currentYearError
            ? `error ${'retail-contribution-editor-limit-error'}`
            : ''
        }`}
      >
        <span
          id={`limitAmount-${fundClassName}`}
          className="retail-contribution-editor-limit-amount"
        >
          <If test={minimum !== 0.01}>
            <span className="retail-contribution-editor-min-max-amount e2e-min-amount">
              Min: {currencyNoPrecision(minimum)}
            </span>
          </If>
          <span className="e2e-max-amount">
            <span className="retail-contribution-editor-min-max-amount">
              {isIRA(fund) ? 'Annual IRA Max: ' : 'Daily Max: '}{' '}
              {currency(maxValue)}
            </span>
          </span>
        </span>
      </div>
      <div
        className={`retail-contribution-editor-info2 ${
          fund.collegePlanMaxError
            ? `error retail-contribution-editor-limit-error`
            : ''
        }`}
      >
        <div className="retail-contribution-editor-min-max-amount">
          {collegePlanMaxValue &&
            `Beneficiary Max: ${currencyNoPrecision(collegePlanMaxValue)}**`}
        </div>
      </div>
      <If
        test={
          fund.newFund &&
          (fund.ticker === 'TRLAX' ||
            fund.ticker === 'TRABX' ||
            fund.ticker === 'TRAVX' ||
            fund.ticker === 'TRATX')
        }
      >
        <RI2020DividendText fund={fund} />
      </If>
      <If test={!isRecurringBuy()}>
        <BankAssociableText showText={fund.bankAssociable} />
      </If>
    </div>
  );
};

export default RetailContributionsEditor;
